// extracted by mini-css-extract-plugin
module.exports = {"instrument-spread":"InstrumentInfo_instrument-spread__GYcHk","instrument-spread-column":"InstrumentInfo_instrument-spread-column__KSZKz"};